export const mobileCutoff = 869;
